<template>
  <CustomerWizardFlow />
</template>

<script>
// @ is an alias to /src
import CustomerWizardFlow from "@/sections/voiceplus/components/CustomerWizardFlow.vue";

export default {
  name: "CustomerWizardFlowView",
  components: {
    CustomerWizardFlow,
  },
};
</script>
